"use strict";
function clamp(value, min, max) {
    if (value < min)
        return min;
    if (value > max)
        return max;
    return value;
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = clamp;
//# sourceMappingURL=clamp.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/pawsong/gdx-ai.js/lib/math/clamp.js
 ** module id = 888
 ** module chunks = 0
 **/